import React, { Component } from "react";
import { loginAction } from "../actions/index";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import logout from "../images/logout_w.png";
import notification from "../images/notifications_white.svg";
import { withRouter, NavLink } from "react-router-dom";
import createHistory from "history/createBrowserHistory";
import api from "../utility/api/api.js";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import edit from "../images/icons8-password-20.png" 
import { ListGroup, ListGroupItem } from "reactstrap";
import loader from "../images/loader.gif";
import eye from "../images/icons8-eye-24.png" 
class HeaderComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { modal: false, action: 1, mark: "Mark In",modalChange:false };
    this.toggle = this.toggle.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.togglePassword = this.togglePassword.bind(this);
    console.log("headercomponent", props);
    const history = createHistory();
    const unlisten = history.listen((location, action) => {
      if (this.state.modal) {
        this.setState({ modal: false });
        //  this.props.history.push('/assigned');
      }
    });
  }
  // componentDidMount() {
  //   localStorage.getItem("user") == null ? this.props.loginAction(true) : "";
  //   this.componentWillReceiveProps();
  //   setInterval(function () {
  //     api.isUserActive()
  //   }.bind(this), 1800000); // Runs every 30 minutes
  // }
  togglePassword(id) {
    var x = document.getElementById(id);
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  }
  async toggle(button) {
    this.setState({ modal: !this.state.modal });
    //  console.log(this.props.history);
    if (button === "logout") {
      const resp = await api.callLogoutApi();
      console.log("logout", resp, resp.status);
      if (
        resp &&
        ((resp[0] && resp[0].status == "success") || resp.status == 401)
      ) {
        localStorage.clear();
        this.props.loginAction(true);

        this.setState({ mark: "Mark In", action: 1 });
        this.props.history.push("/");
      }
    } else if (button === "confirm") this.props.history.push("/logout");
  }
  componentWillReceiveProps() {
    let mark1 = JSON.parse(localStorage.getItem("mark"));
    let { action, mark } = mark1 ? mark1 : { action: 1, mark: "Mark In" };
    this.setState({ action, mark });
  }
  handleClick() {
    console.log('change password')
      this.setState({
      modalChange:!this.state.modalChange
    })
  }
  onSubmit(e) {
    e.preventDefault();
    console.log(  this.state.username)
    this.setState({ isloading: true });
    api.callCreatePasswordApi(
      e.target.username.value,
      e.target.password.value,
      e.target.newpassword.value,  
      this
    );
  }
  render() {
    const token = localStorage.getItem("token")
    return (
      <header
        id="header-component"
        className="rider-header text-center position-fixed"
      >
        <div className="header-left-side">
          {!token ? (
            <span className="text-white hub-header-title">Rider Login</span>
          ) : (
            <div className="deliverOrderHeader">
              {/* <a
                className="float-left text-white"
                onClick={(e) => api.markinoutApi(this.state.action, this)}
              >
                {this.state.mark}
              </a> */}
              {/* <span className="text-white hub-header-title">Rider App</span> */}

              <a
                className="float-left pr-1"
                style={{ cursor: "pointer" }}
                onClick={(e) => this.toggle("confirm")}
              >
                <img src={logout} alt="logout" />
              </a>
              <span className="text-white hub-header-title inTransitHeaderTitle">
                {localStorage.getItem("user")}
              </span>
              {/* <img
                className="float-right pt-1"
                // src={notification}
                // alt="notification"
              /> */}
            <a
               style={{  cursor:"pointer"}}
              title="Change Password"
                onClick={this.handleClick}
              >
               <img src={edit} alt="edit" style={{padding: "3px 3px"}}/>
              </a> 
            </div>
          )}
          <Modal
            isOpen={this.state.modal}
            style={{ position: "absolute", marginTop: "50px" }}
            keyboard={false}
            fade={false}
            toggle={this.toggle}
          >
            <ModalHeader className="justify-content-center py-2 alert-secondary">
              Confirm
            </ModalHeader>
            <ModalBody className="text-center">
              Do You Want to Log Out ???
            </ModalBody>
            <ModalFooter className="p-0 border-0">
              <button className="btn bg-white m-0 py-2" onClick={this.toggle}>
                Cancel
              </button>
              <NavLink
                to="/"
                className="btn m-0 py-2"
                onClick={(e) => this.toggle("logout")}
              >
                OK
              </NavLink>
            </ModalFooter>
          </Modal>
          <Modal
            isOpen={this.state.modalChange}
            className="changePasswordModal"
            // style={{ position: "absolute", right: 0, marginTop: "50px" }}
            keyboard={false}
            fade={false}
            style={{ marginTop: "250px"  }}
          >
            <ModalHeader className="justify-content-center py-2 alert-secondary" >     
                <i className="icon-prevarrow back-btn-arrow" onClick={this.handleClick} style={{margin:"0.5rem"}}></i> 
               Change Password 
            </ModalHeader>
            <ModalBody className="text-center">
              <div className="col-md-12 cc col-sm-12 col-xs-12 form-container col-md-offset-3" style={{ padding: "30px" }}>
                <form className="loginForm" name="changePassword" onSubmit={this.onSubmit} style={{ paddingTop: "0rem" }}>
                  <div className="form-group-collection">
                    <ListGroup>
                      <ListGroupItem
                        color={this.state.color}
                        className="p-0 emailAddress"
                      >
                        <input
                          placeholder="User Name"
                          color="secondary"
                          className="input-text form-control"
                          type="text"
                          name="username"
                          value={localStorage.getItem('user')}
                          required
                        />
                      </ListGroupItem>
                      <ListGroupItem color="light" className="p-0 emailAddress top-border">
                        <div style={{display:"flex",backgroundColor: "#e8e8e8"}}>
                          <div>
                                <input
                                placeholder="Password"
                                color="light"
                                className="input-text form-control"
                                type="password"
                                name="password"
                                id="oldPassword"
                                required
                              />
                          </div>
                        {/* onClick={this.togglePassword} */}
                        <div onClick={()=>this.togglePassword("oldPassword")} className="eyeClass"><img src={eye} alt="eye"/></div>
                        </div>
                      </ListGroupItem>

                      <ListGroupItem color="light" className="p-0 top-border">
                      <div style={{display:"flex",backgroundColor: "#e8e8e8"}}>
                          <div>
                        <input
                          placeholder="New Password"
                          color="light"
                          className="input-text form-control"
                          type="password"
                          name="newpassword"
                          pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                          title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters"
                          required
                          id="newPassword"
                        />
                        </div>
                         <div onClick={()=>this.togglePassword("newPassword")} className="eyeClass"><img src={eye} alt="eye"/></div>
                         </div>
                      </ListGroupItem>
                      <ListGroupItem className="p-0 login-btn">
                        {this.state.isloading ? (
                          <img src={loader} height="40px" />
                        ) : (
                          <input
                            type="submit"
                            className="btn btn-default"
                            value="Submit"
                          />
                        )}
                      </ListGroupItem>
                    </ListGroup>
                  </div>
                  <div className="message"></div>
                </form>
              </div>
            </ModalBody>
            <ModalFooter className="p-0 border-0">
              <button className="btn bg-white m-0 py-2" onClick={this.handleClick}>
                Cancel
              </button>
              {/* <NavLink
                to="/"
                className="btn m-0 py-2"
                onClick={this.handleClick}
              >
                OK
              </NavLink> */}
            </ModalFooter>
          </Modal>

        </div>
      </header>
    );
  }
}
function mapStateToProps(state) {
  return {
    login: state.login,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ loginAction: loginAction }, dispatch);
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HeaderComponent)
);



// WEBPACK FOOTER //
// ./src/components/HeaderComponent.js